export const codeSubmit = () => {
	const urlObject = new URL(window.location.href);
	const baseUrl = urlObject.origin + '/' + window.drupalSettings.path.currentLanguage;
	const codeFormEL = document.getElementById('codeSubmitForm');
	const codePageWrapEl = document.getElementById('pack_promotion');
	const formResetTime = 5000;
	const submitBtn = document.getElementById('redeem_code_submit_btn');
	const codesBlockContentEL = document.getElementById('codes_block_content');
	const codesBlockContentErrorEL = document.getElementById('codes_block_content_error');
	const connectYourAccountBlock = document.getElementById('pep_ea_connect_account');
	const totalCodesResultRow = document.getElementById('code_result_row_total_codes');

	// -----------------------------------------------------------------------------------------------------------------
	// Modal variables
	const _dom = document.querySelector("body");
	const _modalBtns = document.querySelectorAll('.js-open-modal');
	const _modals = document.querySelectorAll('.modal');
	const _backdrop = document.querySelector(".modal-backdrop");

	// -----------------------------------------------------------------------------------------------------------------
	const isNull = (value) => typeof value === "object" && !value;

	function removeClassIfPresent(element, className) {
		if (element.classList.contains(className)) {
			element.classList.remove(className);
		}
	}

	function loader(isLoading) {
		if (isLoading) {
			document.body.classList.add('loading');
		} else {
			document.body.classList.remove('loading');
		}
	}

	function setFormInitialState(wrapEl, classTxt, form) {
		setTimeout(() => {
			wrapEl.classList.remove(classTxt);
			removeClassIfPresent(form, 'has-error');
		}, formResetTime);
	}

	function createCodeListItem(item) {
		let statusClass = '';
		if (item.status === '0') {
			statusClass = 'invalid';
		}
		return `
			<div class="${statusClass} date code-item--cell">${item.date}</div>
			<div class="${statusClass} code code-item--cell">${item.code}</div>
        `;

		// <div class="code-item ${statusClass}">
		//     <span class="date">${item.date}</span>
		//     <span class="code">${item.code}</span>
		// </div>
	}

	function errorLimit() {
		codePageWrapEl.className = ' ';
		codePageWrapEl.classList.add('account-limit-error');
		onInvalidCodesLimitGtm();
	}

	function successLimit() {
		codePageWrapEl.className = ' ';
		codePageWrapEl.classList.add('account-limit-success');
		onValidCodesLimitGtm();
	}

	function hideTotalCodes() {
		totalCodesResultRow.classList.add('hidden');
	}

	function checkLimits(
		{
			participationErrorLimit,
			countTotalError,
			countTotalSuccess,
			countDailySuccess,
			participationSuccessLimit,
			participationDailySuccessLimit,
			isWeeklyPrizeEnabled
		}
	) {

		if (isNull(isWeeklyPrizeEnabled)) {
			hideTotalCodes();
		}
		if (participationErrorLimit && countTotalError >= participationErrorLimit) {
			errorLimit();
		}

		if (participationSuccessLimit && countTotalSuccess >= participationSuccessLimit) {
			successLimit();
		}

		if (participationDailySuccessLimit && countDailySuccess >= participationDailySuccessLimit) {
			successLimit();
		}
	}


	function formResponseHandlers({form = '', responseCode = '', resetForm = false} = {}) {
		if (!submitBtn.classList.contains("active")) {
			submitBtn.classList.add("active");
			setTimeout(function () {
				submitBtn.classList.remove("active");
			}, formResetTime);
		}
		if (responseCode !== '') {
			switch (responseCode) {
				case 'emptyCode':
					form.classList.add('has-error');
					codePageWrapEl.className = ' ';
					codePageWrapEl.classList.add('empty-code-error');
					setFormInitialState(codePageWrapEl, 'empty-code-error', form);
					break;
				case 'invalidCode':
					form.classList.add('has-error');
					codePageWrapEl.className = ' ';
					codePageWrapEl.classList.add('account-error');
					setFormInitialState(codePageWrapEl, 'account-error', form);
					break;
				case 'invalidCodeFormat':
					form.classList.add('has-error');
					codePageWrapEl.className = ' ';
					codePageWrapEl.classList.add('invalid-code-format-error');
					setFormInitialState(codePageWrapEl, 'invalid-code-format-error', form);
					break;
				case 'doubledCode':
					form.classList.add('has-error');
					codePageWrapEl.className = ' ';
					codePageWrapEl.classList.add('invalid-code-doubled-code');
					setFormInitialState(codePageWrapEl, 'invalid-code-doubled-code', form);
					break;
				case 'codeLimitReached':
					form.classList.add('has-error');
					codePageWrapEl.className = ' ';
					codePageWrapEl.classList.add('invalid-code-code-limit-reached');
					setFormInitialState(codePageWrapEl, 'invalid-code-code-limit-reached', form);
					break;
				case 'validCode':
					codePageWrapEl.className = ' ';
					codePageWrapEl.classList.add('account-success');
					setFormInitialState(codePageWrapEl, 'account-success', form);
					break;
				case 'unknownError':
					form.classList.add('has-error');
					codePageWrapEl.className = ' ';
					codePageWrapEl.classList.add('unknown-error');
					setFormInitialState(codePageWrapEl, 'unknown-error', form);
					break;
			}
		}


		if (resetForm) {

			removeClassIfPresent(form, 'has-error');
			codePageWrapEl.className = ' ';
		}
	}


	function updateValidCodeCellValues({count}) {

		// Valid code count
		document.getElementById('valid_code_count').innerHTML = count;
	}

	function updateInvalidCodeCellValues({limit, count}) {
		// Invalid code limit
		if (limit) {
			let invalid_code_count = document.getElementById('invalid_code_limit');
			invalid_code_count.innerHTML = limit;
		}

		// Invalid code count
		let invalid_code_count = document.getElementById('invalid_code_count');
		invalid_code_count.innerHTML = count;
	}


	function updateTotalCodeEntered(val) {
		let total_codes_entered = document.getElementById('total_codes_entered');
		total_codes_entered.innerHTML = val;
	}


	function createCodeList(list) {

		// const codeList = document.getElementById('code_list')
		const validCodeSubList = document.getElementById('valid_code_sub_list');
		const invalidCodeSubList = document.getElementById('invalid_code_sub_list');

		for (var i = 0; i < list.length; i++) {
			const item = list[i];

			// Separate valid and invalid codes
			if (parseInt(item.status) === 0) {
				invalidCodeSubList.insertAdjacentHTML('beforeend', createCodeListItem(item));
			} else if (parseInt(item.status) === 1) {
				if (validCodeSubList) {
					validCodeSubList.insertAdjacentHTML('beforeend', createCodeListItem(item));
				}
			}
		}
	}

	function addToCodeList(code) {

		const invalidCodeSubList = document.getElementById('invalid_code_sub_list');
		// Separate valid and invalid codes
		if (parseInt(code.status) === 0) {
			invalidCodeSubList.insertAdjacentHTML('afterbegin', createCodeListItem(code));
		} else if (parseInt(code.status) === 1) {
			// Valid code list will not be displayed
			// validCodeSubList.insertAdjacentHTML('afterbegin', createCodeListItem(code));
		}

	}

	function showCodesBlockContentError() {
		codesBlockContentEL.classList.add('hide');
		codesBlockContentErrorEL.classList.remove('hide');

	}

	function getCodeList() {
		codePageWrapEl.className = ' ';
		loader(true);
		var codeListUrl = encodeURI(baseUrl + '/pepsifc/codes/list');

		var jqxhr = jQuery.ajax(codeListUrl)
			.done(function (data, status, jqXHR) {
				const statusCode = jqXHR.status;

				if (statusCode === 200) {

					const {
						codes,
						count_daily_success,
						count_total_digital,
						count_total_error,
						count_total_success,
						participation_daily_success_limit,
						participation_error_limit,
						participation_success_limit,
						is_weekly_prize_enabled,
					} = data;


					updateValidCodeCellValues({
						count: count_total_digital
					});
					updateInvalidCodeCellValues({limit: participation_error_limit, count: count_total_error})
					updateTotalCodeEntered(count_total_success);
					createCodeList(codes);
					checkLimits({
						participationErrorLimit: participation_error_limit,
						countTotalError: count_total_error,
						countTotalSuccess: count_total_success,
						countDailySuccess: count_daily_success,
						participationSuccessLimit: participation_success_limit,
						participationDailySuccessLimit: participation_daily_success_limit,
						isWeeklyPrizeEnabled: is_weekly_prize_enabled,
					});


				} else {
					showCodesBlockContentError();
				}

			})
			.fail(function () {
				showCodesBlockContentError();

			})
			.always(function () {
				loader(false);
			});
	}

	function openValidCodeConfirmModal(data) {

		const _modal = document.querySelector("#validCodeConfirmModal");
		const _modal_title = _modal.querySelector('#validCodeConfirmModalTitle');
		const _modal_text = _modal.querySelector('#validCodeConfirmModalText');
		const _modal_button = _modal.querySelector('#validCodeConfirmModalButton');

		// Clear modal text

		// Set modal texts
		_modal_title.innerHTML = data.message.title;
		_modal_text.innerHTML = data.message.text;
		_modal_button.innerHTML = data.message.button;

		// Open Modal
		_modal.classList.add('d-block');

		_modal.removeAttribute('aria-hidden');
		_modal.setAttribute('aria-modal', 'true');
		_modal.setAttribute('role', 'dialog');

		_backdrop.classList.remove('hidden');
		_backdrop.classList.add('fade');

		setTimeout(() => {
			_modal.classList.add('show');
			_backdrop.classList.add('show');
			_dom.classList.add("modal-open");
		}, 100);
	}

	function clientSideCodeValidation(form) {

		const codeInput = form.elements.code.value.trim();
		const countryCode = codeInput.substring(0, 2);
		const code = codeInput.substring(2);

		// regex pattern that will validate if a string contains only the characters 0123456789 ACEFGILNOSTY
		const codeRegex = /^[0123456789ACEFGHJLMNPRTWXY]+$/;
		// regex pattern that will validate if a string contains only uppercase letters.
		const countryCodeRegex = /^[A-Z]+$/;

		let isValide = false;

		if (code === "") {
			// Test if code field is empty
			isValide = false;

		} else if (code.length < 6) {
			// Test only code length, without country code
			isValide = false;

		} else if (!codeRegex.test(code) || !countryCodeRegex.test(countryCode)) {
			// Validate the code and country code:
			// - Code can contain any allowed characters
			// - Country code must be in uppercase letters
			isValide = false;

		} else {
			isValide = true;
		}

		if (!isValide) {
			form.reset();
			formResponseHandlers({form: form, responseCode: "invalidCodeFormat"});
			return false;
		}

		return isValide;
	}

	function submitForm(form) {
		if (!clientSideCodeValidation(form)) {
			return;
		}

		const formFields = form.elements;
		const codeInput = formFields.code;
		const code = codeInput.value.trim();
		if (!code) {
			formResponseHandlers({form: form, responseCode: "emptyCode"});
			return;
		} else if (code.length > 16) {
			form.reset();
			formResponseHandlers({form: form, responseCode: 'invalidCodeFormat'});
			return;
		}
		codePageWrapEl.className = ' ';
		loader(true);


		var jqxhr = jQuery.ajax(encodeURI(baseUrl + '/pepsifc/codes/redeem/' + encodeURIComponent(code)))
			// var jqxhr = jQuery.ajax(baseUrl + '/pepsifc/codes/redeem/' + code)
			.done(function (data, status, jqXHR) {

				if (
					typeof data === 'object' &&
					!Array.isArray(data) &&
					data !== null
				) {

					const codeList = data[0].code_list;
					const firstCode = codeList[0];


					const {
						count_daily_success,
						count_total_digital,
						count_total_error,
						count_total_success,
						participation_daily_success_limit,
						participation_error_limit,
						participation_success_limit,
						is_weekly_prize_enabled,
					} = data[0];


					updateTotalCodeEntered(count_total_success);

					if (data.status === 0) {
						// Invalid Code state
						codePageWrapEl.classList.add('account-error');

						updateValidCodeCellValues({
							count: count_total_digital
						});
						updateInvalidCodeCellValues({limit: participation_error_limit, count: count_total_error});
						if (firstCode) {
							addToCodeList(firstCode);
						}

						onInvalidCodeGtm();
						// formResponseHandlers({form: form, responseCode: 'invalidCodeFormat'});


						formResponseHandlers({form: form, responseCode: 'invalidCode'});
						setTimeout(() => {
							checkLimits({
								participationErrorLimit: participation_error_limit,
								countTotalError: count_total_error,
								countTotalSuccess: count_total_success,
								countDailySuccess: count_daily_success,
								participationSuccessLimit: participation_success_limit,
								participationDailySuccessLimit: participation_daily_success_limit,
								isWeeklyPrizeEnabled: is_weekly_prize_enabled,
							});
						}, formResetTime);

					} else if (data.status === 1) {
						// Valid code state
						if (connectYourAccountBlock) {
							connectYourAccountBlock.classList.add('hide');
						}


						openValidCodeConfirmModal(data);

						updateValidCodeCellValues({
							count: count_total_digital
						});
						updateInvalidCodeCellValues({limit: participation_error_limit, count: count_total_error});
						if (firstCode) {
							addToCodeList(firstCode);
						}

						onValidCodeGtm();

						formResponseHandlers({form: form, responseCode: 'validCode'});

						setTimeout(() => {
							checkLimits({
								participationErrorLimit: participation_error_limit,
								countTotalError: count_total_error,
								countTotalSuccess: count_total_success,
								countDailySuccess: count_daily_success,
								participationSuccessLimit: participation_success_limit,
								participationDailySuccessLimit: participation_daily_success_limit,
								isWeeklyPrizeEnabled: is_weekly_prize_enabled,
							});
						}, formResetTime);

					} else if (data.status === 2) {
						// already redeemed (doubled) state
						formResponseHandlers({form: form, responseCode: 'doubledCode'});
						const errorMsg = 'Already redeemed (doubled)';
						onErrorGtm(errorMsg);
					} else if (data.status === 406) {
						// 406 Code limit reached state
						formResponseHandlers({form: form, responseCode: 'codeLimitReached'});
						const errorMsg = 'Code limit reached';
						onErrorGtm(errorMsg);
					} else {
						// (unknown error) - probably something with API // error code 500 state
						formResponseHandlers({form: form, responseCode: 'unknownError'});
						const errorMsg = '(unknown error) - probably something with API';
						onErrorGtm(errorMsg);

					}
				} else {
					// Invalid data format - Error form server with Status Code: 200 OK
					form.reset();
					loader(false);
				}


			})
			.fail(function (jqXHR, textStatus) {
				console.log("Request failed: " + textStatus);
			})
			.always(function () {
				form.reset();
				loader(false);
			});
	}

// ---------------------------------------------------------------------------------------------------------------------
// Listeners: page load & code submit
// ---------------------------------------------------------------------------------------------------------------------

	if (codeFormEL) {
		document.addEventListener('DOMContentLoaded', () => {
			getCodeList();
		});
		codeFormEL.addEventListener('submit', function (e) {
			e.preventDefault();
			submitForm(e.target);
		});
	}


// ---------------------------------------------------------------------------------------------------------------------
// GTM functions
// ---------------------------------------------------------------------------------------------------------------------

	function onInvalidCodeGtm() {
		// 2. Invalid Code:
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'Participation',
			'Result': 'Invalid Code'
		});
	}

	function onValidCodeGtm() {
		// 3. Valid Code:
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'Participation',
			'Result': 'Valid Code'
		});
	}

	function onErrorGtm(errorMsgEn) {
		// 1. When there is an error and the code can't be submitted. If possible, please also add the error message if we always store the English error message as well (because it doesn't make sense to compare Dutch and English messages in GA later). If that's not possible, just track the Error but without the message:
		if (!errorMsgEn) {
			errorMsgEn = 'No error message'
		}
		console.log("errorMsgEn >> ", errorMsgEn)

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'Participation',
			'Result': 'Error',
			'Error_message': errorMsgEn
		});
	}

	function onValidCodesLimitGtm() {
		// 4. Limit of 10 Valid Codes reached (directly after the 10th valid code)
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'Participation',
			'Result': 'Valid Code Limit Reached'
		});
	}

	function onInvalidCodesLimitGtm() {
		// 5. Limit of 10 Invalid Codes reached (directly after the 10th invalid code):
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'Participation',
			'Result': 'Invalid Code Limit Reached'
		});
	}

};
